module.exports = __webpack_public_path__ + "static/img/20221.5bd363f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20221.jpg
// module id = LlTJ
// module chunks = 1